module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGbc009092560cf51ca0559a58d4f877d3_clip.363186df.png";